import React, { Component } from "react";
import * as Icon from "react-feather";
import clsx from "clsx";

import UtilityService from "../../../../services/UtilityService";

import { CheckStatus } from "./ChecksList";

import ToolsNotice from "../kit/ToolsNotice";

import "./report-sources-panel.css";

class ReportSourcesPanel extends Component {
	describeFile = ({ source }) => {
		const { uploadedReports } = this.props;
		const uploaded = (uploadedReports || []).find(report => report.key === source.reportKey);
		const isReceived = Boolean(uploaded && uploaded.received);
		const fileName = isReceived ? uploaded.fileName : null;
		return { isReceived, fileName };
	};

	describeDifferences = ({ checks }) => {
		const differences = checks.map(check => `${check.label} differs by ${UtilityService.formatMoney({ value: check.difference })}`);
		const differenceSentence = differences.join(" · ");
		return differenceSentence;
	};

	renderStatus = ({ source, isReceived }) => {
		if (!isReceived) {
			return <CheckStatus hasPassed={false} label="Not uploaded" />;
		}

		const checkCount = source.checks.length;
		if (checkCount === 0) {
			return <span className="report-sources__quiet tk-text-muted">Uploaded · nothing in this journal comes from it</span>;
		}

		const figureWord = checkCount === 1 ? "figure" : "figures";
		const label = source.failingCount === 0 ? `${checkCount} ${figureWord} match` : `${source.failingCount} of ${checkCount} out`;
		return <CheckStatus hasPassed={source.failingCount === 0} label={label} />;
	};

	renderSource = ({ source }) => {
		const { isReceived, fileName } = this.describeFile({ source });
		const blockingChecks = source.checks.filter(check => !check.passed && check.isBlocking !== false);
		const noticedChecks = source.checks.filter(check => !check.passed && check.isBlocking === false);
		const hasOutFigure = isReceived && blockingChecks.length > 0;
		const hasNoticedDifference = isReceived && noticedChecks.length > 0;

		return (
			<div className="tk-list__row tk-list__row--compact" key={source.reportKey}>
				<span className={clsx("report-sources__mark", isReceived && "report-sources__mark--received")}>
					{isReceived ? <Icon.FileText size={13} /> : <Icon.AlertTriangle size={13} />}
				</span>
				<div className="tk-list__main">
					<div className="tk-list__title">{source.label}</div>
					<div className="tk-list__subtitle">{fileName || "Drop this export in with the others and build again."}</div>
					{hasOutFigure && <div className="tk-list__subtitle report-sources__out">{this.describeDifferences({ checks: blockingChecks })}</div>}
					{hasNoticedDifference && <div className="tk-list__subtitle">Noted, does not block: {this.describeDifferences({ checks: noticedChecks })}</div>}
				</div>
				<span className="tk-list__trailing">{this.renderStatus({ source, isReceived })}</span>
			</div>
		);
	};

	render() {
		const { reportSources } = this.props;

		if (!reportSources || reportSources.length === 0) {
			return null;
		}

		const sourcesWithFiles = reportSources.map(source => ({ source, ...this.describeFile({ source }) }));
		const missingCount = sourcesWithFiles.filter(entry => !entry.isReceived).length;
		const outCount = sourcesWithFiles.filter(entry => entry.isReceived && entry.source.failingCount > 0).length;
		const isEveryFileMatched = missingCount === 0 && outCount === 0;
		const reportCount = reportSources.length;

		let title = `All ${reportCount} Jane files match this journal`;
		if (missingCount > 0) {
			title = `${missingCount} of ${reportCount} Jane files ${missingCount === 1 ? "is" : "are"} missing`;
		} else if (outCount > 0) {
			title = `${outCount} of ${reportCount} Jane files ${outCount === 1 ? "does" : "do"} not match`;
		}

		return (
			<div className="tk-panel report-sources">
				<ToolsNotice
					tone={isEveryFileMatched ? "success" : "warning"}
					icon={isEveryFileMatched ? <Icon.CheckCircle size={18} /> : <Icon.AlertTriangle size={18} />}
					title={title}
					detail="Each file you uploaded, and every figure this journal took from it, held against what that file states."
				/>
				<div className="tk-list tk-list--flush">{reportSources.map(source => this.renderSource({ source }))}</div>
			</div>
		);
	}
}

export default ReportSourcesPanel;
